import { ComponentWithPermissions } from '../../../../../../../../../baseComponents/CreateRoutering/types'
import { AnimationReady } from '../../../../../../../../../baseComponents/DoubleTable/types'
import TitleAndWhiteBoxLayout from '../../../../../../../../../baseComponents/Layout/TitleAndWhiteBoxLayout'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import TableSellInvoiceAccepted from './TableSellInvoiceAccepted'

type SellInvoicesAcceptedProps = ComponentWithPermissions & AnimationReady & {}

const SellInvoicesAccepted: React.FC<SellInvoicesAcceptedProps> = ({ animationReady }) => {
    const {t} = useTwinTranslation()

    return (
        <TitleAndWhiteBoxLayout title={t('sellInvoiceAvailable', 'Facturas disponibles')}>
            <TableSellInvoiceAccepted animationReady={animationReady} />
        </TitleAndWhiteBoxLayout>
    )
}

export default SellInvoicesAccepted